<section id="container" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="1rem">
  <div id="breakfast-menu" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="1.5rem">
    <!--h1 class="title">Frühstückskarte</h1-->
    <img style="max-width: 80vw" src="../../../assets/fruehstueck_vectorized.svg">
  </div>
</section>
